import React, { Component } from 'react';
import Backdrop             from '../Navigation/Backdrop/Backdrop';
import './Settings.css';

class Settings extends Component {
    render() {
        let {
            onClose,
            visible,
            slides,
            deleteSlide,
            currentSlide
        } = this.props;

        if (!visible) return null;

        return (
            <div className="b-settings">
                <div className="b-settings__menu">
                    <ul>
                        { slides.map((slide, index) => {
                            return (
                                <li className="b-settings__item" key={ index }>
                                    {
                                        currentSlide === index
                                            ? <i title="Текущий слайд" className="fas fa-arrow-right b-settings__icon"/>
                                            : null
                                    }

                                    { slide.props.source.path
                                        ? slide.props.source.path
                                        : `Расписание ${ slide.props.source.date } — ${ slide.props.source.program.map(item => item.time4human).join(', ') }`
                                    }
                                    <button
                                        title="Убрать слайд"
                                        className="b-button b-button--delete"
                                        onClick={ () => deleteSlide(index) }
                                    >
                                        <i className="far fa-trash-alt"/>
                                    </button>
                                </li>
                            );
                        }) }
                    </ul>
                </div>
                { visible ? <Backdrop onClick={ onClose }/> : null }
            </div>
        );
    }
}

export default Settings;
